import { TruncatedText } from "@nulogy/components";
import { formatShortDateTime } from "components/helpers/format";
import PackmanagerJobLink from "components/pages/schedule/PackmanagerJobLink";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import React from "react";
import { ExecutionSummary, PublishResultSection } from "./PublishSummaryModalComponents";

function formatTime({ cellData }) {
  return formatShortDateTime(cellData);
}

function renderWorkOrder({ cellData }) {
  return <TruncatedText pl="x2">{cellData}</TruncatedText>;
}

export default function PublishErrorTabContent({ createErrorRows, updateErrorRows, createTotal, updateTotal }) {
  const applicationContext = useApplicationContext();

  if (createErrorRows.length === 0 && updateErrorRows.length === 0)
    return <ExecutionSummary content="All jobs were published successfully." />;

  const createErrorSummary = `Failed to create ${createErrorRows.length} of ${createTotal} jobs.`;
  const updateErrorSummary = `Failed to update ${updateErrorRows.length} of ${updateTotal} jobs.`;

  const createErrorColumns = [
    {
      cellRenderer: renderWorkOrder,
      dataKey: "workOrder",
      label: "Work order",
      width: "25%",
    },
    {
      dataKey: "line",
      label: "Line",
      width: "20%",
    },
    {
      cellFormatter: formatTime,
      dataKey: "startTime",
      label: "Start time",
      width: "20%",
    },
    {
      dataKey: "error",
      label: "Reason",
      width: "35%",
    },
  ];

  const updateErrorColumns = [
    {
      cellRenderer: renderWorkOrder,
      dataKey: "workOrder",
      label: "Work order",
      width: "20%",
    },
    {
      cellRenderer: renderJob,
      dataKey: "job",
      label: "Job",
      width: "15.1%",
    },
    {
      dataKey: "line",
      label: "Line",
      width: "17.4%",
    },
    {
      cellFormatter: formatTime,
      dataKey: "startTime",
      label: "Start time",
      width: "12.5%",
    },
    {
      dataKey: "error",
      label: "Reason",
      width: "35%",
    },
  ];

  function renderJob({ cellData: jobId }) {
    return <PackmanagerJobLink applicationContext={applicationContext} jobId={jobId} />;
  }

  return (
    <>
      <PublishResultSection
        columns={createErrorColumns}
        rows={createErrorRows}
        summary={createErrorSummary}
        testIdPrefix="create-error"
        title="Create"
      />

      <PublishResultSection
        columns={updateErrorColumns}
        rows={updateErrorRows}
        summary={updateErrorSummary}
        testIdPrefix="update-error"
        title="Update"
      />
    </>
  );
}
